module.exports = __webpack_public_path__ + "static/media/SeaQueen.035f22f9.mp3";